import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import Loader from '../../../tracking/trackingLoading.gif';
import Message from '../../../../../../common/Message';
import { changeProductErrorMsg } from '../../../../../../../constants/Messages';
import { validateProductByMotive } from '../../../../../../../redux/actions/TicketActions';
import { validationBodyGenerator } from '../../../../../../../helpers/tickets/SelfService';
import { useChangeProductStyles } from './styles';
import GenericChangeForm from './GenericChangeForm';
import ChangeExtraOptions from './ChangeExtraOptions';
import CancelPurchase from '../cancelPurchase/CancelPurchase';

const ChangeProduct = ({ ...props }) => {
  const {
    mobile,
    motiveId,
    product,
    type,
    profile,
    validationStatus,
    validation,
  } = props;
  const classes = useChangeProductStyles({ mobile });
  const [selectedExtraOption, setSelectedOption] = useState(null);
  const options = [
    {
      title: 'Llegó dañado',
      subtitle: 'El producto viene con daños que se generaron en el despacho.',
      newForm: { typeId: 2, motiveId: 6 },
    },
    {
      title: 'Me llegó fallado',
      subtitle: 'El producto tiene fallas de fabricación.',
      newForm: { typeId: 2, motiveId: 5 },
    },
    {
      title: 'Llegó otro producto',
      subtitle: 'El producto que llegó no corresponde a lo que compraste.',
      newForm: { typeId: 2, motiveId: 3 },
    },
  ];

  const isCheckedRadio = (newForm) => {
    return selectedExtraOption
      ? selectedExtraOption.motiveId == newForm.motiveId
      : false;
  };

  const handleChangeOption = (newForm) => {
    setSelectedOption(newForm);
  };

  const reduxDispatch = useDispatch();

  useEffect(() => {
    if (mobile)
      reduxDispatch(
        validateProductByMotive(motiveId, validationBodyGenerator(props)),
      );
  }, []);

  return (
    <React.Fragment>
      {validationStatus === 'validating' && (
        <Box display="flex" justifyContent="center" margin="0 auto">
          <img src={Loader} className={classes.loader} />
        </Box>
      )}
      {validationStatus === 'error' && (
        <Box className={classes.container}>
          <Message
            severity="info"
            message={changeProductErrorMsg(validation.id)}
            fullRounded
          />
          {validation.id === 'CONTACT_11' && (
            <React.Fragment>
              <spam className={classes.optionsTitle}>
                Selecciona el inconveniente con tu producto:
              </spam>
              {options.map((item, index) => (
                <ChangeExtraOptions
                  key={index}
                  item={item}
                  isChecked={isCheckedRadio(item.newForm)}
                  handleChangeOption={(newForm) => handleChangeOption(newForm)}
                ></ChangeExtraOptions>
              ))}
            </React.Fragment>
          )}
          {selectedExtraOption && (
            <GenericChangeForm
              mobile={mobile}
              motiveId={selectedExtraOption.motiveId}
              type={selectedExtraOption.typeId}
              product={product}
              profile={profile}
            ></GenericChangeForm>
          )}
        </Box>
      )}
      {validationStatus === 'succeded' && !product.isMkp && (
        <Box className={classes.container}>
          {validation.msg != '' && (
            <Message severity="info" message={validation.msg} fullRounded />
          )}
          <GenericChangeForm
            mobile={mobile}
            motiveId={motiveId}
            type={type}
            product={product}
            profile={profile}
          ></GenericChangeForm>
        </Box>
      )}
      {validationStatus === 'succeded' && product.isMkp && (
        <CancelPurchase
          mobile={mobile}
          product={product}
          motiveId={7}
          type={3}
          profile={profile}
          initialMessage={validation.msg}
        ></CancelPurchase>
      )}
    </React.Fragment>
  );
};

ChangeProduct.propTypes = {
  mobile: PropTypes.bool,
  motiveId: PropTypes.string,
  type: PropTypes.string,
  product: PropTypes.object,
  profile: PropTypes.object,
  validationStatus: PropTypes.string,
  validation: PropTypes.object,
  onData: PropTypes.func,
};

export default ChangeProduct;
